package org.zq.flvtomp4.converter

import kotlinx.coroutines.await
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flow
import org.zq.flvtomp4.platform.WebFileStore
import org.w3c.files.File
import kotlin.js.Promise

actual fun createVideoConverter(
    ffmpegPath: String?,
    ffprobePath: String?,
): VideoConverter = WebVideoConverter()

class WebVideoConverter : VideoConverter {

    override fun convert(request: ConvertRequest): Flow<ConvertEvent> = flow {
        val input = WebFileStore.getInput(request.inputPath)
        if (input == null) {
            emit(
                ConvertEvent.Failed(
                    taskId = request.taskId,
                    message = "找不到浏览器中的输入文件，请重新拖入或选择 FLV",
                ),
            )
            return@flow
        }

        emit(ConvertEvent.Started(taskId = request.taskId, durationMs = 0L))
        emit(
            ConvertEvent.Log(
                taskId = request.taskId,
                message = "正在加载本地 ffmpeg.wasm…",
            ),
        )
        emit(
            ConvertEvent.Progress(
                taskId = request.taskId,
                progress = 0.05f,
                processedMs = 0L,
                speed = null,
            ),
        )

        val preferRemux = request.mode != ConvertMode.TRANSCODE
        try {
            val result = convertWithBridge(input, preferRemux)
            emit(
                ConvertEvent.Progress(
                    taskId = request.taskId,
                    progress = 0.95f,
                    processedMs = 0L,
                    speed = null,
                ),
            )

            val outputName = request.outputPath.substringAfterLast('/')
            WebFileStore.registerOutput(request.outputPath, outputName, result)
            WebFileStore.downloadBytes(outputName, result)

            emit(
                ConvertEvent.Completed(
                    taskId = request.taskId,
                    outputPath = request.outputPath,
                ),
            )
        } catch (error: Throwable) {
            emit(
                ConvertEvent.Failed(
                    taskId = request.taskId,
                    message = error.message ?: "浏览器转换失败",
                ),
            )
        }
    }

    override suspend fun cancel(taskId: String) = Unit
}

private suspend fun convertWithBridge(file: File, preferRemux: Boolean): dynamic {
    val converter = js("window.__flvToMp4")
        ?: error("未加载浏览器 FFmpeg 脚本，请刷新页面后重试")
    val promise = converter.convert(file, preferRemux) as Promise<dynamic>
    return promise.await()
}
